<template>
  <div class="main">
    <Nav />
    <div class="loginForm" v-if="showLoginForm">
      <div class="loginForm-box">
        <img
          src="../images/close-icon.svg"
          alt=""
          @click="handleShowLoginForm"
          class="loginForm-close"
        />
        <p class="title">手机号快捷登录参与活动</p>
        <p class="desc">使用手机号快捷登录，无账号将自动注册</p>
        <input
          type="text"
          class="phone-number"
          placeholder="输入手机号码"
          v-model="phoneNumber"
        />
        <p class="veriPhone" v-show="showPhoneTip">{{ this.veriPhone }}</p>
        <div class="img-code-box">
          <input
            type="text"
            placeholder="输入图形验证码"
            class="imgCodeIpt"
            v-model="imgCodeNumber"
          />
          <img
            src="/ucenter/api/authimage"
            id="img-code"
            @click="changeImgCode"
          />
        </div>
        <p class="veriImg" v-show="showImgTip">{{ this.veriImg }}</p>
        <div class="veri-code-box">
          <input
            type="text"
            class="veri-code"
            placeholder="输入手机验证码"
            v-model="codeNumber"
            maxlength="6"
          />
          <button v-if="!isCounting" class="veri-btn" @click="sendCode">
            {{ this.veriBtn }}
          </button>
          <button v-if="isCounting" class="veri-btn-counting">
            {{ this.veriBtn }}
          </button>
        </div>
        <p class="veriCode" v-show="showCodeTip">{{ this.veriCode }}</p>
        <button class="login-btn" @click="handleLogin">注册登录</button>
        <a
          href="javascript:void(0);"
          class="user-login"
          @click="handleUserLoginShow"
          >账号密码登录</a
        >
      </div>
    </div>
    <div class="loginForm" id="userLoginForm" v-if="showUserLoginForm">
      <div class="loginForm-box">
        <img
          src="../images/close-icon.svg"
          alt=""
          @click="handleShowUserLoginForm"
          class="loginForm-close"
        />
        <p class="title">账号密码登录参与活动</p>
        <p class="desc">使用虹软视觉开放平台账号登录</p>
        <input
          type="text"
          class="user-number"
          placeholder="输入账号"
          v-model="userNumber"
        />
        <p class="veriUser" v-show="showUserTip">{{ this.veriUser }}</p>
        <input
          type="password"
          class="pwd-number"
          placeholder="输入密码"
          v-model="pwdNumber"
        />
        <p class="veriPwd" v-show="showPwdTip">{{ this.veriPwd }}</p>
        <button class="login-btn" @click="handleUserLogin">登录</button>
        <a
          href="javascript:void(0);"
          class="user-login"
          @click="handlePhoneLoginShow"
          >手机号快捷登录</a
        >
      </div>
    </div>
    <div class="signTextAlert" v-if="showSignAlert">
      <div class="signTextAlert-box">
        <p>{{ signText }}</p>
      </div>
    </div>
    <div class="inviteFriendAlert" v-if="showInviteTips">
      <div class="inviteFriendAlert-box">
        <p>您的专属券分享链接已复制成功</p>
        <p>粘贴即可发送给好友</p>
      </div>
    </div>
    <div class="exchangeAlert" v-if="showExchangeConfirmAlert">
      <div class="exchangeAlert-box">
        <img :src="exchangeDetail.imgUrl" alt="" />
        <p class="text1">您正在兑换{{ exchangeDetail.points }}元京东卡</p>
        <p class="text2">本次兑换将消耗{{ exchangeDetail.points }}积分</p>
        <div class="btn">
          <button class="cancel" @click="handleCancelExchangeConfirmAlert">
            取消
          </button>
          <button
            class="confirm"
            @click="handleExchangeConfirmAlert(exchangeDetail.points)"
          >
            确认兑换
          </button>
        </div>
      </div>
    </div>
    <div class="exchangeFailAlert" v-if="showExchangeFailAlert">
      <div class="exchangeFailAlert-box">
        <p class="text1">抱歉~您当前积分不足{{ exchangeDetail.points }}</p>
        <p class="text2">需要更多积分？</p>
        <p class="text3">快把专属券包分享给更多好友吧</p>
        <button class="know" @click="handleExchangeFailAlert">知道了</button>
      </div>
    </div>
    <div class="exchangeSuccessAlert" v-if="showExchangeSuccessAlert">
      <div class="exchangeSuccessAlert-box">
        <p class="text1">{{ exchangeDetail.points }}元京东卡兑换成功</p>
        <p class="text2">可进入【已兑奖品】查看</p>
        <p class="text3">奖品将于活动结束后由虹助手点对点发放</p>
        <div class="btn">
          <button class="cancel" @click="handleCancelExchangeSuccessAlert">
            知道了
          </button>
          <button class="confirm" @click="handleShowPrize('infoCenter')">
            查看已兑奖品
          </button>
        </div>
      </div>
    </div>
    <div class="certifyAlert" v-if="showCertifyAlert">
      <div class="certifyAlert-box">
        <p class="text1">为保障奖品安全准确地分发送达</p>
        <p class="text2">请您先完成认证再进行兑换</p>
        <div class="btn">
          <button class="cancel" @click="handleCancelCertifyAlert">
            先不兑换
          </button>
          <button class="confirm">
            <a
              href="/ucenter/resource/build/index.html#/accountMiddle"
            >
              去认证</a
            >
          </button>
        </div>
      </div>
    </div>
    <div class="banner">
      <img src="../images/banner.png" alt="" />
    </div>
    <div class="banner-mobile">
      <img src="../images/banner-mobile.png" alt="" />
    </div>
    <div class="wrapper">
      <img class="bg1" src="../images/bg1.png" alt="" />
      <img class="bg2" src="../images/bg2.png" alt="" />
      <img class="bg3" src="../images/bg3.png" alt="" />
      <img class="bg4" src="../images/bg4.png" alt="" />
      <img class="bg5" src="../images/bg5.png" alt="" />
      <div class="gift">
        <div class="gift-bg">
          <p>专属券包 礼赠好友</p>
        </div>
        <div class="gift-content">
          <div class="gift-content-left">
            <img src="../images/coupon.png" alt="" />
          </div>
          <div class="gift-content-right">
            <p class="text">
              成为虹推官，分享专属券包给意向好友，受邀好友领券并下单购买，
              您即可获得好友<span
                >实付金额<span class="mm">5%</span>的积分奖励</span
              >，积分可直接按金额1:1兑换京东卡奖品。
            </p>
            <div class="ex">
              <div
                class="invite-friend-btn"
                @click="handleInvite"
                :data-clipboard-text="sign"
              >
                <p>给好友送券包</p>
              </div>
              <p class="aa" @click="handleShowPrize('infoCenter','zhuanshu')">
                专属券领用情况
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="points">
        <div class="points-bg">
          <p>
            我的可兑积分：<span class="myPoint" @click="handleLoginBtn">{{
              currentPoints
            }}</span>
          </p>
        </div>
        <p class="ab" @click="handleShowPrize('infoCenter')">已兑奖品</p>
        <div class="outer">
          <div class="inner">
            <p class="btn" @click="handleExchange(5000)">5000积分兑换</p>
            <img src="../images/c1.png" alt="" class="img" />
            <p class="number">{{ num5000 }}份已兑</p>
          </div>
          <div class="inner">
            <p class="btn" @click="handleExchange(1000)">1000积分兑换</p>
            <img src="../images/c2.png" alt="" class="img" />
            <p class="number">{{ num1000 }}份已兑</p>
          </div>
          <div class="inner">
            <p class="btn" @click="handleExchange(500)">500积分兑换</p>
            <img src="../images/c3.png" alt="" class="img" />
            <p class="number">{{ num500 }}份已兑</p>
          </div>
          <div class="inner">
            <p class="btn" @click="handleExchange(100)">100积分兑换</p>
            <img src="../images/c4.png" alt="" class="img" />
            <p class="number">{{ num100 }}份已兑</p>
          </div>
        </div>
        <div class="points-list">
          <img src="../images/broadcast.png" alt="" />
          <el-carousel
            height="50px"
            direction="vertical"
            :autoplay="true"
            :interval="3000"
            indicator-position="none"
          >
            <el-carousel-item
              class="el-carousel-item"
              v-for="(item, index) in scrollData"
              :key="index"
            >
              <p class="medium">
                恭喜{{ item.phone }}获得{{ item.price }}元京东卡1张
              </p>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="three-steps">
        <div class="three-steps-bg">
          <p>有奖推荐 三步完成</p>
        </div>
        <div class="three-steps-content">
          <div class="item">
            <img src="../images/11.png" alt="" />
            <p class="text1">分享专属券包</p>
            <p class="text2">虹推官复制链接对外</p>
            <p class="text3">分享专属优惠券</p>
          </div>
          <img class="triangle" src="../images/triangle.png" alt="" />
          <div class="item">
            <img src="../images/22.png" alt="" />
            <p class="text1">好友领券下单</p>
            <p class="text2">受邀好友领专属券</p>
            <p class="text3">并用券下单购买</p>
          </div>
          <img class="triangle" src="../images/triangle.png" alt="" />
          <div class="item">
            <img src="../images/33.png" alt="" />
            <p class="text1">成功获得奖励</p>
            <p class="text2">虹推官可获好友实付金额5%的</p>
            <p class="text3">返现奖励</p>
          </div>
        </div>
      </div>
      <div class="example">
        <p class="text1">
          举例：小A将专属券包分享给小B；
          小B领取后使用专属券在平台下单购买了200个SDK激活码，券后实付22800元；
        </p>
        <p class="text2">
          此时小A即可获得1100个积分(22800*5%，保留至百位数),
          可兑换价值1100元的京东卡。
        </p>
      </div>
      <div class="activity-question">
        <img src="../images/qrcode.png" alt="" />
        <div class="right-content">
          <p>领取京东卡奖励或咨询活动规则 请扫码添加官方虹助手</p>
          <div>
            <ul>
              <li>
                <img src="../images/qr1.png" alt="" />
                <p>京东卡奖励点对点发放</p>
              </li>
              <li>
                <img src="../images/qr2.png" alt="" />
                <p>产品技术支持及购买问题答疑</p>
              </li>
              <li>
                <img src="../images/qr3.png" alt="" />
                <p>行业干货分享、不定期社群抽奖</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="activity">
        <p class="activity-heading">活动细则</p>
        <div class="rule first">
          <img src="../images/rule1.png" alt="" />
          <p class="title">活动时间</p>
          <p>2021年9月6日-10月15日</p>
        </div>
        <div class="rule second">
          <img src="../images/rule2.png" alt="" />
          <p class="title">参与人群</p>
          <p>平台内认证用户</p>
        </div>
        <div class="rule third">
          <img src="../images/rule3.png" alt="" />
          <p class="title">活动内容</p>
        </div>
        <div class="content">
          <p class="text1">
            活动期间，平台用户完成认证即可成为虹软虹推官。
            虹推官分享专属优惠券包给意向好友，好友通过专属
          </p>
          <p class="text2">
            优惠券购买平台产品、并完成付款，
            即视为虹推官成功推荐好友下单，可获得奖励积分，积分可直接按金
          </p>
          <p class="text3">额1:1兑换京东卡奖品。</p>
          <p class="text4">95折专属优惠券包</p>
          <p class="text5"><span>1.</span> 针对人脸识别增值版产品：</p>
          <p class="text6">
            95折 折扣券，适用于人脸识别增值版产品，起购量在100台-1999台可用；
          </p>
          <p class="text7"><span>2.</span> 针对APP人脸识别增值版产品：</p>
          <p class="text8">
            1500 元满减券，适用于APP人脸识别增值版产品，满3万元可用；
          </p>
          <p class="text9">
            好友通过邀请人用户的专属优惠券购买平台产品、并完成付款，即视为邀请人成功推荐好友下单。
          </p>
          <p class="text10">虹推官返现奖励规则</p>
          <p class="text11">
            <span>1.</span>
            奖励计算方式：虹推官奖励积分=所邀好友实付金额*5%，积分值保留至百位数;
          </p>
          <p class="text12">
            <span>2.</span>
            好友通过您分享的专属优惠券进行下单付款，即视为您已成功推荐好友下单，可获得奖励；
          </p>
          <p class="text13">
            <span>3.</span>
            虹推官奖励积分根据以上方式计算得出后，在活动期间累计和消耗，逾期作废，请您在活动期间及时兑换奖品；
          </p>
          <p class="text14">
            <span>4.</span>
            所兑京东卡将在活动结束且审核完成后30个工作日内，通过虹助手点对点发放。
          </p>
          <p class="text15">优惠券领取规则及使用方法</p>
          <p class="text16">
            <span>1.</span>
            活动期间，邀请人专属优惠券分享数量不设限制，受邀人领取和使用数量不设限制；
          </p>
          <p class="text17">
            <span>2.</span>
            优惠券仅限企业实名认证用户使用，未认证及个人认证用户请完成企业认证后使用，
            本活动中受邀好友的购买订单不支持退款；
          </p>
          <p class="text18">
            <span>3.</span>
            优惠券不可叠加使用，每笔订单仅限使用1张优惠券；
            人脸识别增值版产品相关折扣券可与平台现行的阶梯优惠同享;
          </p>
          <p class="text19">
            <span>4.</span>
            优惠券仅活动期间有效，逾期失效，请在适用范围内尽快使用;
          </p>
          <p class="text20">
            <span>5.</span>
            如有任何使用问题，可联系官方虹助手或提交工单，我们将及时为您解答。
          </p>
        </div>
        <div class="tips">
          <p class="tips-title">注意事项</p>
          <p>
            1.
            对于通过恶意注册或其他不正当手段在本次活动中进行非法牟利、炒作、转售、获奖的用户，
            虹软视觉开放平台有权取消其获奖资格或其因参加活动所获权益；
          </p>
          <p>2. 虹软视觉开放平台在法律允许的范围内享有对本活动的解释权。</p>
        </div>
      </div>
    </div>
    <div class="wrapper-mobile">
      <div class="gift">
        <div class="gift-bg">
          <p>专属券包 礼赠好友</p>
        </div>
        <img class="coupon" src="../images/coupon.png" alt="" />
        <p class="text">
          成为虹推官，分享专属券包给意向好友，
          受邀好友领券并下单购买，您即可获得好友<span>实付金额<span>5%</span>的积分奖励</span>，
          积分可直接按金额1:1兑换京东卡奖品。
        </p>
        <div
          class="invite-friend-btn"
          @click="handleInvite"
          :data-clipboard-text="sign"
        >
          <p>给好友送券包</p>
        </div>
        <p class="aa" @click="handleShowPrize('infoCenter','zhuanshu')">专属券领用情况</p>
      </div>
      <div class="points">
        <div class="points-bg">
          <p>
            我的可兑积分：<span class="myPoint" @click="handleLoginBtn">{{
              currentPoints
            }}</span>
          </p>
        </div>
        <p class="ab" @click="handleShowPrize('infoCenter')">已兑奖品</p>
        <div class="inner">
          <p class="btn" @click="handleExchange(5000)">5000积分兑换</p>
          <img src="../images/c1.png" alt="" class="img" />
          <p class="number">{{ num5000 }}份已兑</p>
        </div>
        <div class="inner">
          <p class="btn" @click="handleExchange(1000)">1000积分兑换</p>
          <img src="../images/c2.png" alt="" class="img" />
          <p class="number">{{ num1000 }}份已兑</p>
        </div>
        <div class="inner">
          <p class="btn" @click="handleExchange(500)">500积分兑换</p>
          <img src="../images/c3.png" alt="" class="img" />
          <p class="number">{{ num500 }}份已兑</p>
        </div>
        <div class="inner">
          <p class="btn" @click="handleExchange(100)">100积分兑换</p>
          <img src="../images/c4.png" alt="" class="img" />
          <p class="number">{{ num100 }}份已兑</p>
        </div>
        <div class="points-list">
          <img src="../images/broadcast.png" alt="" />
          <el-carousel
            height="50px"
            direction="vertical"
            :autoplay="true"
            :interval="3000"
            indicator-position="none"
          >
            <el-carousel-item
              class="el-carousel-item"
              v-for="(item, index) in scrollData"
              :key="index"
            >
              <p class="medium">恭喜{{ item.phone }}</p>
              <p class="medium">获得{{ item.price }}元京东卡1张</p>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="three-steps">
        <div class="three-steps-bg">
          <p>有奖推荐 三步完成</p>
        </div>
        <div class="three-steps-item">
          <img src="../images/11.png" alt="" />
          <div class="right-content">
            <p class="text1">分享专属券包</p>
            <p class="text2">虹推官复制链接对外</p>
            <p class="text3">分享专属优惠券</p>
          </div>
        </div>
        <div class="three-steps-item">
          <img src="../images/22.png" alt="" />
          <div class="right-content">
            <p class="text1">好友领券下单</p>
            <p class="text2">受邀好友领专属券</p>
            <p class="text3">并用券下单购买</p>
          </div>
        </div>
        <div class="three-steps-item">
          <img src="../images/33.png" alt="" />
          <div class="right-content">
            <p class="text1">成功获得奖励</p>
            <p class="text2">虹推官可获好友实付</p>
            <p class="text3">金额5%的返现奖励</p>
          </div>
        </div>
        <p class="example">
          举例：小A将专属券包分享给小B；
          小B领取后使用专属券在平台下单购买了200个SDK激活码，
          券后实付22800元；此时小A即可获得1100个积分(22800*5%，保留至百位数),
          可兑换价值1100元的京东卡。
        </p>
        <div class="activity-question">
          <div class="title">
            <p>领取京东卡奖励或咨询活动规则 请扫码添加官方虹助手</p>
            <img src="../images/qrcode.png" alt="" />
          </div>
          <ul>
            <li>
              <img src="../images/qr1.png" alt="" />
              <p>京东卡奖励点对点发放</p>
            </li>
            <li>
              <img src="../images/qr2.png" alt="" />
              <p>产品技术支持及购买问题答疑</p>
            </li>
            <li>
              <img src="../images/qr3.png" alt="" />
              <p>行业干货分享、不定期社群抽奖</p>
            </li>
          </ul>
        </div>
        <div class="activity">
          <p class="activity-heading">活动细则</p>
          <div class="rule first">
            <img src="../images/rule1.png" alt="" />
            <p class="title">活动时间</p>
          </div>
          <p>2021年9月6日-10月15日</p>
          <div class="rule second">
            <img src="../images/rule2.png" alt="" />
            <p class="title">参与人群</p>
          </div>
          <p>平台内认证用户</p>
          <div class="rule third">
            <img src="../images/rule3.png" alt="" />
            <p class="title">活动内容</p>
          </div>
          <!-- 活动细则内容 -->
          <div class="content">
            <p class="text1">
              活动期间，平台用户完成认证即可成为虹软虹推官。
              虹推官分享专属优惠券包给意向好友，
              好友通过专属优惠券购买平台产品、并完成付款，
              即视为虹推官成功推荐好友下单，可获得奖励积分，
              积分可直接按金额1:1兑换京东卡奖品。
            </p>
            <p class="text2">95折专属优惠券包</p>
            <p class="text3"><span>1. </span>针对人脸识别增值版产品</p>
            <p class="text4">
              95折 折扣券，适用于人脸识别增值版产品， 起购量在100台-1999台可用。
            </p>
            <p class="text5"><span>2. </span>针对APP人脸识别增值版产品</p>
            <p class="text6">
              1500 元满减券，
              适用于APP人脸识别增值版产品，满3万元可用；
            </p>
            <p class="text7">
              好友通过邀请人用户的专属优惠券购买平台产品、并完成付款，
              即视为邀请人成功推荐好友下单。
            </p>
            <p class="text8">虹推官返现奖励规则</p>
            <p class="text9">
              <span>1. </span>奖励计算方式：
              虹推官奖励积分=所邀好友实付金额*5%，积分值保留至百位数；
            </p>
            <p class="text10">
              <span>2. </span>好友通过您分享的专属优惠券进行下单付款，
              即视为您已成功推荐好友下单，可获得奖励；
            </p>
            <p class="text11">
              <span>3. </span>虹推官奖励积分根据以上方式计算得出后，在活动期间累计和消耗，逾期作废，请您在活动期间及时兑换奖品；
            </p>
            <p class="text12 mt">
              <span>4. </span>所兑京东卡将在活动结束且审核完成后30个工作日内，
              通过虹助手点对点发放。
            </p>
            <p class="text8">优惠券领取规则及使用方法</p>
            <p class="text9">
              <span>1. </span>活动期间，邀请人专属优惠券分享数量不设限制，
              受邀人领取和使用数量不设限制；
            </p>
            <p class="text10">
              <span>2. </span
              >优惠券仅限企业实名认证用户使用，未认证及个人认证用户请完成企业认证后使用，
              本活动中受邀好友的购买订单不支持退款；
            </p>
            <p class="text11 ht">
              <span>3. </span>优惠券不可叠加使用，每笔订单仅限使用1张优惠券；
              人脸识别增值版产品相关折扣券可与平台现行的阶梯优惠同享;
            </p>
            <p class="text11 ht">
              <span>4. </span
              >优惠券仅活动期间有效，逾期失效，请在适用范围内尽快使用;
            </p>
            <p class="text12 ht">
              <span>5. </span
              >如有任何使用问题，可联系官方虹助手或提交工单，我们将及时为您解答。
            </p>
          </div>
          <div class="tips">
            <p class="tips-title">注意事项</p>
            <p>
              1.
              对于通过恶意注册或其他不正当手段在本次活动中进行非法牟利、炒作、转售、获奖的用户，
              虹软视觉开放平台有权取消其获奖资格或其因参加活动所获权益；
            </p>
            <p>2. 虹软视觉开放平台在法律允许的范围内享有对本活动的解释权。</p>
            <p></p>
          </div>
        </div>
      </div>
    </div>
    <span
      v-show="false"
      class="copyU"
      ref="copy"
      :data-clipboard-text="sign"
      @click="copy"
    ></span>
    <div id="invite-mobile-btn-wrap" v-if="isBtnShow">
      <button
        id="invite-mobile-btn"
        class="invite-friend-btn"
        @click="handleInvite"
        :data-clipboard-text="sign"
      >
        给好友送券包
      </button>
    </div>
    <div class="backTop" @click="backTop" v-show="isBackTopShow">^Top</div>
  </div>
</template>

<script>
import $ from "jquery";
import ClipboardJS from "clipboard";
import Nav from "../components/nav.vue";
// import { post } from "../utils/request";
export default {
  name: "Home",
  components: { Nav },
  data() {
    return {
      showSignAlert: false,
      signText: "",
      signFlag: true,
      hasCertified: false,
      exchangeDetail: {
        imgUrl: "",
        points: "",
      },
      showExchangeConfirmAlert: false,
      showExchangeFailAlert: false,
      showExchangeSuccessAlert: false,
      showCertifyAlert: false,
      isBtnShow: false,
      isBackTopShow: false,
      sign: "",
      showLoginForm: false,
      showUserLoginForm: false,
      veriPhone: "",
      veriCode: "",
      veriImg: "",
      phoneNumber: "",
      codeNumber: "",
      imgCodeNumber: "",
      showCodeTip: false,
      showPhoneTip: false,
      showInviteTips: false,
      showImgTip: false,
      veriBtn: "获取短信验证码",
      isCounting: false,
      isImgCodeTrue: false,
      userNumber: "",
      showUserTip: false,
      veriUser: "",
      pwdNumber: "",
      showPwdTip: false,
      veriPwd: "",
      scrollData: [],
      currentPoints: "登录查看", //用户积分
      num100: 0,
      num500: 0,
      num1000: 0,
      num5000: 0,
    };
  },
  created() {
    this.getExchangeInfo();
    this.checkUserStatus();
  },
  mounted() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    if (document.location.href.indexOf("ai.arcsoft.com.cn") > 0) {
      gtag("config", "UA-7959274-33");
    } else {
      gtag("config", "UA-7959274-34");
    }
    /* 监听窗口宽度 */
    const that = this;
    window.onresize = () => {
      return (() => {
        that.screenWidth = document.body.clientWidth;
      })();
    };
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll(e) {
      // console.log(
      //   "e.srcElement.scrollingElement.scrollTop",
      //   e.srcElement.scrollingElement.scrollTop
      // );
      if (e.srcElement.scrollingElement.scrollTop >= 400) {
        this.isBackTopShow = true;
      } else {
        this.isBackTopShow = false;
      }
      if (e.srcElement.scrollingElement.scrollTop <= 325) this.isBtnShow = true;
      else if (
        e.srcElement.scrollingElement.scrollTop >= 1020 &&
        this.showLoginForm == false
      ) {
        this.isBtnShow = true;
      } else {
        this.isBtnShow = false;
      }
    },
    backTop() {
      const timer = setInterval(() => {
        document.documentElement.scrollTop -= 100;
        if (document.documentElement.scrollTop == 0) {
          clearInterval(timer);
        }
      }, 20);
    },
    //获取用户登录状态
    async checkUserStatus() {
      let { data } = await this.$axios.post("/operator/new-version/query");
      if (data.retObj !== null && data.retObj.userId > 0) {
        //用户处于登录状态
        this.getPoints();
        this.getSignId();
        $(".myPoint").css("cursor","default");
        $(".myPoint").css("text-decoration","none");
      } else {
        //用户处于未登录状态
      }
    },
    // 获取积分兑换信息
    async getExchangeInfo() {
      let { data } = await this.$axios.post(
        "/operator/recommend/pointExchangeInfo",
        {
          remark: 202109,
        }
      );
      this.scrollData = data.retObj.phoneExchangeList;
      data.retObj.pointExchangeList.forEach((item) => {
        if (item.points == 100) {
          this.num100 = item.count;
        } else if (item.points == 500) {
          this.num500 = item.count;
        } else if (item.points == 1000) {
          this.num1000 = item.count;
        } else if (item.points == 5000) {
          this.num5000 = item.count;
        } else {
        }
      });
    },
    //点击登录查看
    async handleLoginBtn() {
      let { data } = await this.$axios.post("/operator/new-version/query");
      if (data.retObj !== null && data.retObj.userId > 0) {
        this.getSignId();
        this.getPoints();
        this.getExchangeInfo();
      } else {
        this.showLoginForm = true;
      }
    },
    // 点击积分兑换 在点击积分兑换的时候调query接口，拿认证状态
    async handleExchange(points) {
      gtag('event', '积分兑换', {'event_category' : '推荐下单活动', 'event_label' : 'click1'});
      let { data } = await this.$axios.post("/operator/new-version/query");
      if (data.retObj !== null && data.retObj.userId > 0) {
        this.hasCertified = data.retObj.hasCertified;
        if (this.hasCertified) {
          //已经认证用户开始判断积分
          //先判断积分是否足够兑换
          this.exchangeDetail.points = points;
          if (this.currentPoints >= points) {
            this.showExchangeConfirmAlert = true;
            if (points >= 5000) {
              this.exchangeDetail.imgUrl = require("../images/c1.png");
            } else if (points < 5000 && points >= 1000) {
              this.exchangeDetail.imgUrl = require("../images/c2.png");
            } else if (points < 1000 && points >= 500) {
              this.exchangeDetail.imgUrl = require("../images/c3.png");
            } else {
              this.exchangeDetail.imgUrl = require("../images/c4.png");
            }
          } else {
            //积分不足
            this.showExchangeFailAlert = true;
          }
        } else {
          //未认证用户 弹出认证提醒框
          this.showCertifyAlert = true;
        }
      } else {
        this.showLoginForm = true;
      }
    },
    async handleExchangeConfirmAlert(points) {
      //先调接口 兑换成功后把确认框消掉，把兑换成功框显示出来
      let { data } = await this.$axios.post(
        "/operator/recommend/pointExchange",
        {
          remark: 202109,
          value: points,
        }
      );
      if (data.success == true) {
        this.currentPoints -= points;
        //或者重新调一次getPoints方法
        // this.getPoints();
        this.showExchangeConfirmAlert = false;
        this.showExchangeSuccessAlert = true;
        this.getExchangeInfo();
      }
    },
    handleCancelExchangeConfirmAlert() {
      this.showExchangeConfirmAlert = false;
    },
    handleExchangeFailAlert() {
      this.showExchangeFailAlert = false;
    },
    handleCancelCertifyAlert() {
      this.showCertifyAlert = false;
    },
    handleCancelExchangeSuccessAlert() {
      this.showExchangeSuccessAlert = false;
    },
    async handleShowPrize(id,title) {
      var Id = id;
      if(title) {
        gtag('event', '专属券领用情况', {'event_category' : '推荐下单活动', 'event_label' : 'click1'});
      } else {
        gtag('event', '已兑奖品', {'event_category' : '推荐下单活动', 'event_label' : 'click1'});
      }
      localStorage.setItem("toId", Id);
      let { data } = await this.$axios.post("/operator/new-version/query");
      if (data.retObj !== null && data.retObj.userId > 0) {
        this.$router.push("/detail");
      } else {
        this.showLoginForm = true;
      }
    },
    /* 点击一键邀请 */
    async handleInvite() {
      gtag('event', '给好友送券包', {'event_category' : '推荐下单活动', 'event_label' : 'click1'});
      //isBtnShow 是控制移动端底部悬浮按钮的变量，移动端点完悬浮按钮后，把按钮消掉
      this.isBtnShow = false;
      //这里点击给好友送券包的按钮，去掉获取邀请码的接口
      let { data } = await this.$axios.post(
        "/operator/recommend/getInvitateLink",
        { remark: 202109 }
      );
      if (data.retMsg == "用户未登录") {
        this.showLoginForm = true;
      } else if (this.signFlag) {
        this.sign =
          window.location.host +
          "/operator/resource/recommend/2021/index.html#/share?sign=" +
          data.retObj;
        this.$forceUpdate();
        setTimeout(() => {
          //模拟点击真正复制链接的按钮
          this.$refs.copy.click();
        }, 10);
      } else {
        //对邀请码做异常处理
        this.showSignFlag = true;
      }
    },
    //复制方法
    copy(evnet) {
      evnet.preventDefault();
      let clipboard = new ClipboardJS(".copyU");
      clipboard.on("success", (e) => {
        this.showInviteTips = true;
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.inviteTipsContent = "该浏览器不支持自动复制,请更换浏览器重试";
        this.showInviteTips = true;
        // 释放内存
        clipboard.destroy();
      });
      setTimeout(() => {
        this.showInviteTips = false;
      }, 2000);
    },
    // 获取用户积分
    async getPoints() {
      let { data } = await this.$axios.post("/operator/recommend/getPoints", {
        remark: 202109,
      });
      //用户积分先写死 测逻辑 然后再打开
      if (data.retMsg == "用户未登录") {
        this.currentPoints = "登录查看";
      } else {
        this.currentPoints = data.retObj;
      }
    },
    /* 获取用户UUID */
    async getSignId() {
      let { data } = await this.$axios.post(
        "/operator/recommend/getInvitateLink",
        { remark: 202109 }
      );
      if (data.retMsg == "ok") {
        this.sign =
          window.location.host +
          "/operator/resource/recommend/2021/index.html#/share?sign=" +
          data.retObj;
      } else {
        this.signFlag = false;
        this.signText = data.retMsg;
      }
    },
    /* 切换验证码 */
    changeImgCode() {
      $("#img-code").attr("src", "/ucenter/api/authimage?" + Math.random());
    },
    /* 短信验证码登录 */
    async handleLogin() {
      if (this.imgCodeNumber == "" || this.imgCodeNumber == null) {
        this.veriImg = "请输入图形验证码";
        this.showImgTip = true;
      }
      if (this.phoneNumber == "" || this.phoneNumber == null) {
        this.veriPhone = "请输入手机号";
        this.showPhoneTip = true;
      }
      if (this.codeNumber == "" || this.codeNumber == null) {
        this.veriCode = "请输入验证码";
        this.showCodeTip = true;
      }
      if (this.phoneNumber && !/^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)) {
        this.veriPhone = "手机号格式不正确";
        this.showPhoneTip = true;
      }
      /* 用户登录 */
      if (
        this.phoneNumber &&
        /^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber) == true &&
        this.isImgCodeTrue == true
      ) {
        this.showPhoneTip = false;
        this.showCodeTip = false;
        this.showImgTip = false;
        let dataObj = {
          phone: this.phoneNumber,
          smsValidCode: this.codeNumber,
          regSource: 19,
          regDeviceType: 1,
          imgValidCode: this.imgCodeNumber,
        };
        if (localStorage.getItem("utmSource")) {
          dataObj.sourcePage = localStorage.getItem("sourcePage");
          dataObj.utmSource = localStorage.getItem("utmSource");
          dataObj.utmMedium = localStorage.getItem("utmMedium");
          dataObj.utmCampaign = localStorage.getItem("utmCampaign");
        }
        let { data } = await this.$axios.post(
          "/ucenter/user/LoginForCode",
          dataObj
        );
        if (data.success == true) {
          $(".myPoint").css("cursor","default");
          $(".myPoint").css("text-decoration","none");
          this.getSignId();
          this.getPoints();
          this.getExchangeInfo();
          // this.hasCertified = data.retObj.certifyStatus === 2 ? true : false;
          this.showLoginForm = false;
        } else {
          this.veriCode = "验证码输入错误";
          this.showCodeTip = true;
        }
      }
    },
    /* 发送验证码 */
    async sendCode() {
      if (this.phoneNumber == "" || this.phoneNumber == null) {
        this.veriPhone = "请输入手机号";
        this.showPhoneTip = true;
      } else if (
        this.phoneNumber &&
        !/^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)
      ) {
        this.veriPhone = "手机号格式不正确";
        this.showPhoneTip = true;
      } else {
        this.showPhoneTip = false;
      }
      if (this.imgCodeNumber == "" || this.imgCodeNumber == null) {
        this.veriImg = "请输入图形验证码";
        this.showImgTip = true;
        return;
      }
      if (this.phoneNumber && /^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)) {
        this.showPhoneTip = false;
        let { data } = await this.$axios.post(
          "/ucenter/API/SMSService/SendRegKeyV2?t=" + Math.random(),
          {
            phoneNum: this.phoneNumber,
            imageCode: this.imgCodeNumber,
          }
        );
        if (data.success == false) {
          this.veriImg = "图形验证码错误";
          this.showImgTip = true;
        } else {
          this.isImgCodeTrue = true;
          this.showImgTip = false;
          this.isCounting = true;
          var time = 60;
          var countDown = setInterval(() => {
            time--;
            this.veriBtn = "重新发送" + time;
            if (time == 0) {
              this.isCounting = false;
              this.veriBtn = "获取短信验证码";
              clearInterval(countDown);
            }
          }, 1000);
        }
      }
    },
    //用户账号密码登录
    async handleUserLogin() {
      if (!this.userNumber) {
        this.showUserTip = true;
        this.veriUser = "请输入用户名";
      } else if (!this.pwdNumber) {
        this.showPwdTip = true;
        this.veriPwd = "请输入密码";
      } else {
        let { data: res } = await this.$axios.post("/ucenter/user/Login", {
          email: this.userNumber,
          passwd: this.pwdNumber,
        });
        if (res.success == true) {
          $(".myPoint").css("cursor","default");
          $(".myPoint").css("text-decoration","none");
          this.getSignId();
          this.getPoints();
          this.getExchangeInfo();
          // this.hasCertified = res.retObj.certifyStatus === 2 ? true : false;
          this.showUserLoginForm = false;
        } else {
          this.showPwdTip = true;
          this.veriPwd = "用户名或密码错误";
          this.showUserTip = false;
        }
      }
    },
    handleUserLoginShow() {
      this.showLoginForm = false;
      this.showUserLoginForm = true;
    },
    handlePhoneLoginShow() {
      this.showUserLoginForm = false;
      this.showLoginForm = true;
    },
    handleShowLoginForm() {
      // this.changeImgCode();
      this.isImgCodeTrue = false;
      this.showLoginForm = false;
      this.showPhoneTip = false;
      this.showCodeTip = false;
      this.showImgTip = false;
      this.phoneNumber = "";
      this.imgCodeNumber = "";
      this.codeNumber = "";
    },
    handleShowUserLoginForm() {
      this.showUserLoginForm = false;
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  position: relative;
  overflow: hidden;
  #invite-mobile-btn {
    display: none;
  }
  .banner {
    display: block;
    img {
      width: 100%;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
    }
  }
  .banner-mobile {
    display: none;
  }
  .loginForm {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    .loginForm-box {
      position: relative;
      width: 384px;
      height: 400px;
      background-color: #1e0150;
      border-radius: 16px;
      overflow: hidden;
      .title {
        margin-top: 48px;
        font-size: 22px;
        font-weight: bolder;
        color: #ffffff;
        text-align: center;
      }
      .desc {
        color: #d9d9d9;
        margin-top: 7px;
        font-size: 14px;
        margin-bottom: 32px;
        text-align: center;
      }
      .img-code-box {
        display: flex;
        align-items: center;
        width: 256px;
        height: 32px;
        box-sizing: border-box;
        margin: 0 auto 24px;
        input {
          width: 152px;
          height: 32px;
          border-radius: 2px;
          border: solid 1px #ffffff;
          box-sizing: border-box;
          padding-left: 10px;
          background-color: transparent;
          outline: none;
          color: #ffffff;
        }
        img {
          width: 100px;
          height: 32px;
          margin-left: 4px;
        }
        input::placeholder {
          color: #ffffff;
          opacity: 0.5;
        }
      }
      .veri-code-box {
        display: flex;
        /* align-items: center; */
        width: 256px;
        height: 32px;
        box-sizing: border-box;
        margin: 0 auto 24px;
      }
      .phone-number,
      .user-number,
      .pwd-number,
      .veri-code {
        width: 256px;
        height: 32px;
        background-color: transparent;
        margin-bottom: 24px;
        border-radius: 2px;
        outline: none;
        border: solid 1px #ffffff;
        padding-left: 10px;
        color: #fff;
        box-sizing: border-box;
      }
      .phone-number {
        margin-left: 65px;
      }
      .veri-code {
        width: 152px;
        height: 37px;
        background-color: transparent;
        border-radius: 2px;
        outline: none;
        border: solid 1px #ffffff;
        padding-left: 10px;
        color: #fff;
        box-sizing: border-box;
        &::placeholder {
          color: #ffffff;
          opacity: 0.5;
        }
        &.md {
          left: 20px;
          color: #ffffff;
        }
      }
      .pwd-number {
        width: 256px;
        height: 32px;
        background-color: transparent;
        margin-bottom: 24px;
        border-radius: 2px;
        outline: none;
        border: solid 1px #ffffff;
        padding-left: 10px;
        color: #fff;
        box-sizing: border-box;
      }
      .user-number {
        margin-left: 65px;
      }
      .pwd-number {
        margin-left: 65px;
      }
      .user-number::placeholder {
        color: #ffffff;
        opacity: 0.5;
      }
      .pwd-number::placeholder {
        color: #ffffff;
        opacity: 0.5;
      }
      .phone-number::placeholder {
        color: #ffffff;
        opacity: 0.5;
      }
      .veri-btn {
        width: 152px;
        height: 37px;
        cursor: pointer;
        background-color: transparent;
        border: solid 1px #ffb758;
        color: #ffb758;
        border-radius: 3px;
        outline: none;
        padding: 10px 6px;
        font-size: 12px;
        margin-left: 4px;
      }
      .veri-btn-counting {
        width: 152px;
        height: 37px;
        background-color: transparent;
        border: solid 1px #fff258;
        color: #ffd831;
        border-radius: 3px;
        margin-left: 4px;
        outline: none;
        font-size: 12px;
      }
      .loginForm-close {
        display: block;
        float: right;
        cursor: pointer;
        height: 18px;
        margin: 13px;
      }
      .login-btn {
        display: block;
        font-size: 14px;
        width: 256px;
        height: 33px;
        margin: 0 auto;
        margin-bottom: 21px;
        margin-top: 3px;
        color: #ffffff;
        font-weight: 700;
        letter-spacing: 1px;
        cursor: pointer;
        border: none;
        outline: none;
        background-image: linear-gradient(233deg, #ff7b41 0%, #ff7e7e 100%);
        border-radius: 4px;
        box-sizing: border-box;
      }
      .user-login {
        width: 85px;
        height: 12px;
        font-size: 12px;
        line-height: 12px;
        letter-spacing: 0px;
        color: #ffffff;
        display: block;
        margin: 0 auto;
        padding-left: 14px;
      }
      .veriPhone,
      .veriCode,
      .veriUser,
      .veriPwd,
      .veriImg {
        position: absolute;
        left: 64px;
        color: red;
        font-size: 13px;
      }
      .veriPhone {
        margin-top: -25px;
      }
      .veriPwd {
        color: red;
        font-size: 13px;
        text-align: left;
        margin-top: -22px;
      }
      .veriUser {
        margin-top: -22px;
      }
      .veriCode,
      .veriPwd {
        margin-top: -20px;
        // left: 20px;
      }
      .veriImg {
        top: 224px;
      }
    }
  }
  .signTextAlert {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    &-box {
      width: 384px;
      height: 80px;
      background-color: #1e0150;
      border: solid 1px #fed590;
      border-radius: 16px;
      p {
        width: 288px;
        height: 18px;
        font-size: 18px;
        line-height: 18px;
        letter-spacing: 0px;
        color: #ffffff;
        margin: 0 auto;
        text-align: center;
      }
    }
  }
  .inviteFriendAlert {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    .inviteFriendAlert-box {
      width: 384px;
      height: 80px;
      background-color: #1e0150;
      border: solid 1px #fed590;
      border-radius: 16px;
      p {
        width: 288px;
        height: 18px;
        font-size: 18px;
        line-height: 18px;
        letter-spacing: 0px;
        color: #ffffff;
        margin: 0 auto;
        text-align: center;
        &:first-child {
          margin-top: 15px;
        }
        &:last-child {
          margin-top: 10px;
        }
      }
    }
  }
  .exchangeAlert {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    &-box {
      width: 365px;
      height: 320px;
      background-color: #1e0150;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.5);
      border-radius: 8px;
      border: solid 1px #fed590;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 210px;
      }
      .text1,
      .text2 {
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #ffffff;
      }
      .text1 {
        margin-top: 16px;
      }
      .text2 {
        margin-top: 8px;
      }
      .btn {
        margin-top: 24px;
        .cancel {
          width: 88px;
          height: 41px;
          border-radius: 2px;
          border: solid 1px #fed590;
          color: #fed590;
          font-size: 14px;
          background-color: #1e0150;
          letter-spacing: 1px;
          font-size: 16px;
          cursor: pointer;
        }
        .confirm {
          width: 108px;
          height: 41px;
          background-image: linear-gradient(270deg, #ff783b 0%, #fda280 100%);
          border-radius: 2px;
          font-size: 14px;
          color: #ffffff;
          margin-left: 16px;
          border: none;
          letter-spacing: 1px;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
  }
  .exchangeFailAlert {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    &-box {
      width: 335px;
      height: 230px;
      background-color: #1e0150;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.5);
      border-radius: 8px;
      border: solid 1px #fed590;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text1,
      .text2,
      .text3 {
        color: #ffffff;
      }
      .text1 {
        font-size: 20px;
      }
      .text2 {
        margin-top: 16px;
        font-size: 18px;
      }
      .text3 {
        margin-top: 5px;
        font-size: 18px;
      }
      .know {
        cursor: pointer;
        width: 98px;
        height: 41px;
        background-image: linear-gradient(270deg, #ff783b 0%, #fda280 100%);
        border-radius: 2px;
        color: #ffffff;
        font-size: 16px;
        border: none;
        margin-top: 24px;
        letter-spacing: 1px;
        cursor: pointer;
      }
    }
  }
  .exchangeSuccessAlert {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    &-box {
      width: 370px;
      height: 230px;
      background-color: #1e0150;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.5);
      border-radius: 8px;
      border: solid 1px #fed590;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text1,
      .text2,
      .text3 {
        color: #ffffff;
      }
      .text1 {
        font-size: 20px;
      }
      .text2 {
        margin-top: 16px;
        font-size: 18px;
      }
      .text3 {
        margin-top: 5px;
        font-size: 18px;
      }
      .btn {
        margin-top: 24px;
        .cancel {
          width: 88px;
          height: 41px;
          border-radius: 2px;
          border: solid 1px #fed590;
          color: #fed590;
          background-color: #1e0150;
          letter-spacing: 1px;
          font-size: 16px;
          cursor: pointer;
        }
        .confirm {
          width: 120px;
          height: 41px;
          background-image: linear-gradient(270deg, #ff783b 0%, #fda280 100%);
          border-radius: 2px;
          color: #ffffff;
          margin-left: 16px;
          border: none;
          letter-spacing: 1px;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
  }
  .certifyAlert {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    &-box {
      width: 370px;
      height: 230px;
      background-color: #1e0150;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.5);
      border-radius: 8px;
      border: solid 1px #fed590;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text1,
      .text2 {
        font-size: 18px;
        color: #ffffff;
      }
      .text2 {
        margin-top: 8px;
      }
      .btn {
        margin-top: 24px;
        .cancel {
          width: 88px;
          height: 41px;
          border-radius: 2px;
          border: solid 1px #fed590;
          color: #fed590;
          font-size: 14px;
          background-color: #1e0150;
          letter-spacing: 1px;
          font-size: 16px;
          cursor: pointer;
        }
        .confirm {
          width: 108px;
          height: 41px;
          background-image: linear-gradient(270deg, #ff783b 0%, #fda280 100%);
          border-radius: 2px;
          font-size: 14px;
          color: #ffffff;
          margin-left: 16px;
          border: none;
          letter-spacing: 1px;
          font-size: 16px;
          cursor: pointer;
          a {
            text-decoration: none;
            color: #ffffff;
          }
        }
      }
    }
  }
  .wrapper-mobile {
    display: none;
  }
  .wrapper {
    width: 100%;
    height: 3680px;
    position: relative;
    background-color: #1e0050;
    padding-top: 80px;
    position: relative;
    .bg1 {
      position: absolute;
      right: -120px;
      z-index: 1;
    }
    .bg2 {
      position: absolute;
      top: 901px;
      left: -80px;
    }
    .bg3 {
      position: absolute;
      top: 1376px;
      right: -140px;
    }
    .bg4 {
      position: absolute;
      top: 2417px;
      left: -78px;
    }
    .bg5 {
      position: absolute;
      top: 3186px;
      right: -120px;
    }
    .gift {
      width: 100%;
      height: 590px;
      &-bg {
        width: 400px;
        height: 156px;
        margin: 0 auto;
        background-image: url(../images/gift-bg.png);
        background-position: center;
        background-size: 100% auto;
        background-repeat: no-repeat;
        p {
          font-size: 40px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 68px;
          letter-spacing: 2px;
          color: #ffffff;
          margin: 0 auto;
          padding-top: 36px;
          padding-left: 26px;
        }
      }
      &-content {
        display: flex;
        width: 1049px;
        margin: 22px auto 0;
        &-left {
          margin-right: 59px;
          img {
            width: 518px;
            height: 317px;
          }
        }
        &-right {
          width: 472px;
          height: 102px;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 40px;
          letter-spacing: 1px;
          color: #f3f3f3;
          .text {
            padding-top: 78px;
            span {
              font-weight: 700;
              .mm {
                color: #fed590;
              }
            }
          }
          .ex {
            display: flex;
            align-items: center;
            margin-top: 41px;
            .invite-friend-btn {
              width: 280px;
              height: 56px;
              margin-right: 45px;
              background-image: linear-gradient(
                233deg,
                #bf2d2c 0%,
                #fb7130 100%
              );
              border-radius: 24px;
              cursor: pointer;
              p {
                width: 280px;
                height: 48px;
                font-size: 18px;
                color: #ffffff;
                background-image: linear-gradient(
                  233deg,
                  #ff783b 0%,
                  #fda280 100%
                );
                border-radius: 24px;
                text-align: center;
                line-height: 48px;
                transition: all 0.3s linear;
              }
              p:hover {
                height: 53px;
                line-height: 53px;
              }
            }
            .aa {
              text-decoration: underline;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 60px;
              letter-spacing: 1px;
              color: #fed590;
              cursor: pointer;
            }
          }
        }
      }
    }
    .points {
      width: 1234px;
      height: 590px;
      margin: 0 auto;
      &-bg {
        width: 1234px;
        height: 80px;
        margin: 0 auto;
        background-image: url(../images/points-bg.png);
        background-position: center;
        background-size: 100% auto;
        background-repeat: no-repeat;
        p {
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 80px;
          letter-spacing: 1px;
          color: #ffffff;
          text-align: center;
          span {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
      .ab {
        width: 60px;
        display: block;
        text-decoration: underline;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #fed590;
        margin: 24px auto 0;
        cursor: pointer;
      }
      .outer {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1234px;
        height: 224px;
        margin-top: 120px;
        .inner {
          position: relative;
          width: 279px;
          height: 224px;
          text-align: center;
          img {
            width: 279px;
            height: 165px;
            transition: all 0.3s linear;
          }
          .btn {
            position: absolute;
            top: 135px;
            left: 41px;
            width: 192px;
            height: 48px;
            line-height: 48px;
            border-radius: 33px;
            color: #ffffff;
            cursor: pointer;
            transition: all 0.3s linear;
            z-index: 999;
            background-image: linear-gradient(270deg, #ff783b 0%, #d67a67 100%);
            box-shadow: 0px 0px 20px 0px #2a167e;
            border: solid 2px #ffa47b;
          }
          .btn:hover {
            transform: scale(1.2);
            & + .img {
              transform: translateY(-10px);
            }
          }
          &:not(:last-child) {
            margin-right: 43px;
          }
          .number {
            height: 14px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 14px;
            letter-spacing: 1px;
            color: #ffffff;
            margin-top: 45px;
          }
        }
      }
      &-list {
        width: 420px;
        height: 48px;
        background-color: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
        border: solid 1px #fed590;
        margin: 80px auto 0;
        position: relative;
        img {
          width: 20px;
          height: 21px;
          position: absolute;
          top: 13px;
          left: 20px;
        }
        .el-carousel-item {
          top: 35%;
        }
        p {
          height: 14px;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 14px;
          letter-spacing: 1px;
          text-align: left;
          padding-left: 63px;
          color: #ffffff;
        }
      }
    }
    .three-steps {
      width: 990px;
      height: 425px;
      margin: 100px auto 0;
      &-bg {
        width: 597px;
        height: 20px;
        margin: 0 auto;
        background-image: url(../images/three-steps-bg.png);
        background-position: center;
        background-size: 100% auto;
        background-repeat: no-repeat;
        position: relative;
        p {
          height: 40px;
          font-size: 40px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 40px;
          letter-spacing: 2px;
          color: #ffffff;
          position: absolute;
          top: -22px;
          left: 121px;
        }
      }
      &-content {
        display: flex;
        align-items: center;
        margin: 80px auto 0;
        width: 1003px;
        .item {
          img {
            width: 268px;
          }
          .text1 {
            height: 20px;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 20px;
            letter-spacing: 1px;
            color: #ffffff;
            text-align: center;
            margin-top: 31px;
          }
          .text2,
          .text3 {
            height: 16px;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 16px;
            letter-spacing: 1px;
            color: rgba(255, 255, 255, 0.6);
            text-align: center;
          }
          .text2 {
            margin-top: 16px;
          }
          .text3 {
            margin-top: 6px;
          }
        }
        .item:not(:last-child) {
          margin-right: 13px;
        }
        .triangle {
          width: 67px;
          height: 14px;
          margin-top: -100px;
          margin-right: 13px;
        }
      }
    }
    .example {
      width: 873px;
      margin: 80px auto 0;
      .text1,
      .text2 {
        height: 16px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 16px;
        letter-spacing: 1px;
        color: #f3f3f3;
      }
      .text2 {
        margin-top: 7px;
      }
    }
    .activity-question {
      width: 745px;
      margin: 112px auto 0;
      display: flex;
      img {
        width: 300px;
        height: 300px;
        margin-right: 52px;
      }
      .right-content {
        width: 392px;
        height: 76px;
        font-size: 28px;
        line-height: 48px;
        letter-spacing: 0px;
        color: #ffffff;
        ul {
          list-style-type: none;
          li {
            display: flex;
            margin-bottom: 24px;
            &:first-child {
              margin-top: 64px;
            }
            img {
              width: 19px;
              height: 18px;
              margin-right: 10px;
            }
            p {
              width: 253px;
              height: 18px;
              font-size: 18px;
              line-height: 18px;
              letter-spacing: 0px;
              color: #ffffff;
            }
          }
        }
      }
    }
    .activity {
      width: 992px;
      height: 1280px;
      border-radius: 8px;
      margin: 96px auto 0;
      background-color: rgba(255, 255, 255, 0.1);
      box-sizing: border-box;
      padding-top: 66px;
      &-heading {
        height: 22px;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 4px;
        color: #ffffff;
        text-align: center;
      }
      .rule {
        display: flex;
        align-items: center;
        margin-left: 108px;
        > img {
          width: 32px;
          height: 32px;
          margin-right: 28px;
        }
        .title {
          width: 96px;
          height: 20px;
          font-size: 20px;
          line-height: 20px;
          letter-spacing: 4px;
          color: #fed590;
          margin-right: 24px;
        }
        &.first {
          margin-top: 78px;
          p:last-child {
            height: 14px;
            font-size: 14px;
            line-height: 14px;
            letter-spacing: 3px;
            color: #ffffff;
          }
        }
        &.second {
          margin-top: 28px;
          p:last-child {
            height: 14px;
            font-size: 14px;
            line-height: 14px;
            letter-spacing: 3px;
            color: #ffffff;
          }
        }
        &.third {
          margin-top: 28px;
        }
      }
      .content {
        width: 698px;
        height: 18px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 18px;
        letter-spacing: 1px;
        color: #ffffff;
        margin-left: 114px;
        margin-top: 20px;
        .text2,
        .text3 {
          margin-top: 6px;
        }
        .text4,
        .text10,
        .text15 {
          margin-top: 16px;
          color: #fed590;
        }
        .text5,
        .text7,
        .text11,
        .text12,
        .text13,
        .text14,
        .text15,
        .text16,
        .text17,
        .text18,
        .text19,
        .text20 {
          line-height: 22px;
          margin-top: 16px;
          span {
            font-weight: 700;
            color: #fed590;
          }
        }
        .text6,
        .text7,
        .text8,
        .text9 {
          margin-top: 16px;
        }
      }

      .tips {
        width: 76px;
        height: 16px;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 3px;
        color: #ffffff;
        margin-left: 111px;
        margin-top: 775px;
        p:not(:first-child) {
          width: 713px;
          height: 60px;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 3px;
          color: #ffffff;
          margin-left: 64px;
        }
        p:nth-child(2) {
          margin-top: 20px;
        }
      }
    }
  }
  .backTop {
    width: 40px;
    height: 40px;
    font-size: 13px;
    text-align: center;
    position: fixed;
    right: 100px;
    bottom: 60px;
    border-radius: 50%;
    background-color: rgba(254, 188, 68, 0.9);
    cursor: pointer;
    line-height: 40px;
    color: #4a3a10;
    z-index: 999999;
  }
}
@media screen and (max-width: 750px) {
  .main {
    .banner {
      display: none;
    }
    .banner-mobile {
      display: block;
      img {
        width: 100%;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
      }
    }
    .signTextAlert {
      &-box {
        width: 288px;
        height: 104px;
        border-radius: 16px;
        padding-top: 35px;
        p {
          height: 18px;
          font-size: 16px;
        }
      }
    }
    .inviteFriendAlert {
      .inviteFriendAlert-box {
        width: 288px;
        height: 104px;
        border-radius: 16px;
        padding-top: 35px;
        p {
          height: 18px;
          font-size: 16px;
        }
      }
    }
    .exchangeAlert {
      &-box {
        width: 260px;
        height: 249px;
        img {
          width: 135px;
        }
        .text1,
        .text2 {
          font-size: 14px;
        }
        .btn {
          .cancel {
            width: 80px;
            font-size: 14px;
          }
          .confirm {
            width: 100px;
            font-size: 14px;
          }
        }
      }
    }
    .exchangeSuccessAlert-box {
      width: 260px;
      height: 188px;
      .text1 {
        font-size: 18px;
      }
      .text2,
      .text3 {
        font-size: 14px;
      }
      .btn {
        .cancel {
          width: 80px;
          font-size: 14px;
        }
        .confirm {
          width: 102px;
          font-size: 14px;
        }
      }
    }
    .exchangeFailAlert {
      &-box {
        width: 260px;
        height: 188px;
        .text1 {
          font-size: 18px;
        }
        .text2,
        .text3 {
          font-size: 14px;
        }
        .know {
          font-size: 14px;
        }
      }
    }
    .certifyAlert {
      &-box {
        width: 260px;
        height: 164px;
        .text1,
        .text2 {
          font-size: 14px;
        }
        .btn {
          .cancel {
            width: 80px;
            font-size: 14px;
          }
          .confirm {
            width: 100px;
            font-size: 14px;
          }
        }
      }
    }
    .loginForm {
      .loginForm-box {
        width: 290px;
        height: 335px;
        border-radius: 8px;
        padding-bottom: 10px;
        box-sizing: border-box;
        border: solid 1px #fed590;
        .veri-btn-counting{
          height: 30px;
          margin-left: 10px;
        }
        .loginForm-close {
          width: 17px;
          height: 17px;
        }
        .title {
          height: 14px;
          font-size: 14px;
          line-height: 14px;
          letter-spacing: 0px;
          margin: 46px auto 10px;
          text-align: center;
        }
        .loginForm-close {
          height: 12px;
        }
        .desc {
          height: 11px;
          font-size: 11px;
          line-height: 11px;
          letter-spacing: 0px;
          margin: 0 auto 10px;
        }
        .phone-number {
          width: 250px;
          height: 30px;
          border-radius: 1px;
          margin-bottom: 17px;
          margin-left: 20px;
          margin-top: 20px;
        }
        .img-code-box {
          margin: 0 auto 17px;
          input {
            width: 120px;
            height: 30px;
            border-radius: 1px;
            margin-left: 3px;
          }
          img {
            width: 120px;
            height: 30px;
            /* background-color: rgba(255, 255, 255, 0.5); */
            border-radius: 1px;
            margin-left: 10px;
          }
        }
        .veriPhone {
          margin-top: -18px;
          left: 20px;
        }
        .veriImg {
          top: 189px;
          left: 20px;
        }
        .veriUser {
          margin-top: -18px;
          left: 20px;
        }
        .veriPwd {
          margin-top: -18px;
          left: 20px;
          margin-left: 0;
        }
        .veri-code-box {
          margin-bottom: 17px;
          & + p {
            left: 20px;
          }
        }
        .veri-code {
          width: 120px;
          height: 30px;
          border-radius: 1px;
          margin-left: 3px;
        }
        .veri-btn {
          width: 120px;
          height: 30px;
          border-radius: 1px;
          margin-left: 10px;
          padding: 0;
        }
        .login-btn {
          width: 250px;
          height: 30px;
          font-size: 12px;
          margin-bottom: 10px;
        }
        .user-login {
          height: 11px;
          font-size: 11px;
          line-height: 11px;
          letter-spacing: 0px;
          margin-top: 15px;
        }
      }
    }
    #userLoginForm {
      .loginForm-box {
        height: 300px;
        .user-number {
          width: 250px;
          height: 30px;
          margin-bottom: 18px;
          margin-left: 20px;
          margin-top: 24px;
        }
        .pwd-number {
          width: 250px;
          height: 30px;
          margin-bottom: 18px;
          margin-left: 20px;
        }
      }
    }
    #invite-mobile-btn-wrap {
      width: 100%;
      height: 80px;
      display: block;
      background-color: rgba(56, 63, 123, 0.85);
      overflow: hidden;
      position: fixed;
      bottom: 0;
      z-index: 9999;
      #invite-mobile-btn {
        display: block;
        width: 380px;
        height: 50px;
        line-height: 50px;
        display: block;
        color: #fff;
        text-align: center;
        background-image: linear-gradient(233deg, #ff783b 0%, #fda280 100%);
        border: none;
        outline: none;
        border-radius: 5px;
        font-size: 16px;
        margin: 0 auto;
        margin-top: 15px;
      }
    }
    .backTop {
      display: none;
    }
    .wrapper {
      display: none;
    }
    .wrapper-mobile {
      overflow: hidden;
      display: block;
      width: 100%;
      height: 3870px;
      position: relative;
      background-color: #1e0050;
      .gift {
        width: 100%;
        height: 625px;
        &-bg {
          width: 294px;
          height: 115px;
          margin: 0 auto;
          background-image: url(../images/gift-bg.png);
          background-position: center;
          background-size: 100% auto;
          background-repeat: no-repeat;
          p {
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 110px;
            letter-spacing: 1px;
            color: #ffffff;
            text-align: center;
          }
        }
        .coupon {
          width: 100%;
          height: auto;
        }
        .text {
          width: 280px;
          height: 110px;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 28px;
          letter-spacing: 1px;
          color: #f3f3f3;
          margin: 7px auto 34px;
          span {
            font-weight: 700;
            span {
              color: #fed590;
            }
          }
        }
        .invite-friend-btn {
          width: 280px;
          height: 56px;
          margin: 0 auto;
          border-radius: 24px;
          background-image: linear-gradient(233deg, #bf2d2c 0%, #fb7130 100%);
          p {
            width: 280px;
            height: 48px;
            font-size: 18px;
            color: #ffffff;
            background-image: linear-gradient(233deg, #ff783b 0%, #fda280 100%);
            border-radius: 24px;
            text-align: center;
            line-height: 48px;
          }
        }
        .aa {
          text-decoration: underline;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 48px;
          letter-spacing: 1px;
          color: #fed590;
          display: block;
          margin: 6px auto 0;
          width: 106px;
          cursor: pointer;
        }
      }
      .points {
        margin-top: 32px;
        &-bg {
          width: 100%;
          height: 80px;
          background-image: url(../images/points-bg.png);
          background-position: center;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          p {
            height: 20px;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 80px;
            letter-spacing: 1px;
            color: #ffffff;
            margin: 0 auto;
            text-align: center;
            span {
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }
        .ab {
          width: 60px;
          height: 14px;
          text-decoration: underline;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 14px;
          letter-spacing: 1px;
          color: #fed590;
          display: block;
          margin: 24px auto 51px;
          cursor: pointer;
        }
        .inner {
          position: relative;
          width: 279px;
          height: 224px;
          margin: 0 auto;
          img {
            width: 279px;
            height: 165px;
          }
          .btn {
            position: absolute;
            top: 138px;
            left: 44px;
            width: 192px;
            height: 48px;
            line-height: 48px;
            border-radius: 33px;
            color: #ffffff;
            z-index: 999;
            background-image: linear-gradient(270deg, #ff783b 0%, #d67a67 100%);
            box-shadow: 0px 0px 20px 0px #2a167e;
            border: solid 2px #ffa47b;
            text-align: center;
          }
          .number {
            height: 14px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 14px;
            letter-spacing: 1px;
            color: #ffffff;
            margin-top: 45px;
            text-align: center;
          }
        }
        .inner:not(:last-child) {
          margin-bottom: 41px;
        }
        &-list {
          width: 280px;
          height: 71px;
          background-color: rgba(255, 255, 255, 0.2);
          border-radius: 4px;
          border: solid 1px #fed590;
          margin: 65px auto 0;
          position: relative;
          img {
            width: 20px;
            height: 21px;
            position: absolute;
            top: 25px;
            left: 27px;
          }
          .el-carousel-item {
            top: 40%;
          }
          p {
            height: 14px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 14px;
            letter-spacing: 1px;
            text-align: left;
            padding-left: 63px;
            color: #ffffff;
            + p {
              margin-top: 3px;
            }
          }
        }
      }
      .three-steps {
        &-bg {
          width: 279px;
          height: 10px;
          margin: 80px auto 40px;
          background-image: url(../images/three-steps-bg.png);
          background-position: center;
          background-size: 100% auto;
          background-repeat: no-repeat;
          position: relative;
          p {
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 34px;
            letter-spacing: 1px;
            color: #ffffff;
            position: absolute;
            top: -20px;
            left: 50px;
          }
        }
        &-item {
          display: flex;
          align-items: center;
          width: 278px;
          margin: 0 auto;
          img {
            width: 89px;
            margin-right: 18px;
          }
          .right-content {
            .text1 {
              height: 20px;
              font-size: 20px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 1px;
              color: #ffffff;
              margin-bottom: 18px;
            }
            .text2,
            .text3 {
              height: 14px;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 14px;
              letter-spacing: 1px;
              color: rgba(255, 255, 255, 0.6);
            }
            .text3 {
              margin-top: 6px;
            }
          }
        }
        &-item:not(:last-child) {
          margin-bottom: 40px;
        }
        .example {
          width: 278px;
          height: 100px;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 22px;
          letter-spacing: 1px;
          color: #f3f3f3;
          margin: 45px auto 60px;
        }
        .activity-question {
          .title {
            p {
              width: 280px;
              height: 54px;
              font-size: 20px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 34px;
              letter-spacing: 0px;
              color: #ffffff;
              margin: 0 auto;
              text-align: center;
            }
            > img {
              width: 280px;
              height: 280px;
              margin: 32px auto 0;
              display: block;
            }
          }
          ul {
            margin: 31px auto 0;
            li {
              display: flex;
              justify-content: center;
              margin-bottom: 24px;
              img {
                width: 20px;
                height: 20px;
                margin-right: 10px;
              }
              p {
                width: 252px;
                height: 18px;
                font-size: 18px;
                line-height: 18px;
                letter-spacing: 0px;
                color: #ffffff;
              }
            }
          }
        }
        .activity {
          width: 280px;
          height: 600px;
          background-color: rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          margin: 81px auto 0;
          padding-top: 14px;
          box-sizing: border-box;
          overflow-y: auto;
          overflow-x: hidden;
          &-heading {
            width: 77px;
            height: 16px;
            font-size: 16px;
            line-height: 16px;
            letter-spacing: 3px;
            color: #ffffff;
            margin: 0 auto;
          }
          .rule {
            display: flex;
            align-items: center;
            margin-left: 16px;
            > img {
              width: 16px;
              height: 16px;
              margin-right: 10px;
              margin-top: -2px;
            }
            .title {
              width: 68px;
              height: 14px;
              font-size: 14px;
              line-height: 14px;
              letter-spacing: 3px;
              color: #fed590;
            }
            &.first {
              margin-top: 24px;
              + p {
                height: 14px;
                font-size: 12px;
                line-height: 14px;
                letter-spacing: 2px;
                color: #ffffff;
                margin-left: 42px;
                margin-top: 8px;
              }
            }
            &.second {
              margin-top: 19px;
              + p {
                height: 14px;
                font-size: 12px;
                line-height: 14px;
                letter-spacing: 2px;
                color: #ffffff;
                margin-left: 42px;
                margin-top: 8px;
              }
            }
            &.third {
              margin-top: 19px;
            }
            &.fourth {
              margin-top: 96px;
              p {
                width: 242px;
              }
            }
            &.fifth {
              margin-top: 60px;
              p {
                width: 120px;
              }
            }
          }
          //活动细则内容
          .content {
            .text1 {
              width: 222px;
              height: 140px;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 2px;
              color: #ffffff;
              margin: 19px auto 0;
            }
            .text2 {
              width: 222px;
              height: 15px;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 2px;
              color: #fed590;
              margin: 16px auto 0;
            }
            .text3,
            .text5,
            .text9,
            .text10,
            .text11,
            .text12 {
              height: 16px;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 2px;
              color: #ffffff;
              margin-top: 16px;
              margin-left: 29px;
              span {
                font-size: 14px;
                letter-spacing: 3px;
                color: #fed590;
              }
            }
            .text4 {
              width: 217px;
              height: 57px;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 2px;
              color: #ffffff;
              margin: 12px auto 0;
            }
            .text5 {
              margin-top: 8px;
            }
            .text6,
            .text7 {
              width: 217px;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 2px;
              color: #ffffff;
              margin: 12px auto;
            }
            .text7 {
              margin: -10px auto;
            }
            .text8 {
              width: 222px;
              height: 16px;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 2px;
              color: #fed590;
              margin: 22px auto 0;
            }
            .text9,
            .text10,
            .text11,
            .text12 {
              width: 222px;
              height: 48px;
            }
            .text11.ht {
              margin-top: 38px;
            }
            .text12.ht {
              margin-top: 0;
            }
            .text12.mt{
              margin-top: 35px;
            }
          }
          .tips {
            width: 76px;
            height: 14px;
            font-size: 14px;
            line-height: 14px;
            letter-spacing: 3px;
            color: #ffffff;
            margin-left: 28px;
            margin-top: 32px;
            padding-right: 32px;
            padding-bottom: 14px;
            p:not(:first-child) {
              width: 220px;
              height: 18px;
              font-size: 12px;
              line-height: 18px;
              letter-spacing: 2px;
              color: #ffffff;
            }
            p:nth-child(2) {
              margin-top: 20px;
            }
            p:nth-child(3) {
              margin-top: 80px;
            }
            p:last-child {
              margin-top: 30px;
            }
          }
        }
      }
    }
  }
}
</style>
